const index = (resolve) => require(["@/page/index"], resolve);
const home = (resolve) => require(["@/page/home"], resolve);
const login = (resolve) => require(["@/page/login"], resolve);
const welcome = (resolve) => require(["@/page/welcome"], resolve);
const newly = (resolve) => require(["@/page/ly/newly"], resolve);
const nDetails = (resolve) => require(["@/page/ly/details"], resolve);
const Infomation = (resolve) => require(["@/page/infomation/index"], resolve);
const InDetails = (resolve) => require(["@/page/infomation/details"], resolve);
const payback = (resolve) => require(["@/page/payback/list"], resolve);
const paybackDetails = (resolve) =>
  require(["@/page/payback/details"], resolve);
const paybacksee = (resolve) => require(["@/page/payback/edit"], resolve);
const examineManage = (resolve) => require(["@/page/examine/index"], resolve);
const directoryManage = (resolve) =>
  require(["@/page/directory/index"], resolve);
const directoryAdd = (resolve) => require(["@/page/directory/add"], resolve);
const allCar = (resolve) => require(["@/page/directory/car"], resolve);
const action = (resolve) => require(["@/page/directory/action"], resolve);
const overStep = (resolve) => require(["@/page/directory/over"], resolve);
const accountManage = (resolve) => require(["@/page/account/index"], resolve);
const accountGroup = (resolve) => require(["@/page/account/group"], resolve);
const accountAdd = (resolve) => require(["@/page/account/add"], resolve);
const accountOperationLog = (resolve) =>
  require(["@/page/account/OperationLog"], resolve);
const accountLoginlist = (resolve) =>
  require(["@/page/account/loginlist"], resolve);
const subjectActionManage = (resolve) =>
  require(["@/page/subjectAction/index"], resolve);
const litigationStatistics = (resolve) =>
  require(["@/page/litigationStatistics/index"], resolve);
const stepStatistics = (resolve) =>
  require(["@/page/litigationStatistics/step"], resolve);
const collectionAmount = (resolve) =>
  require(["@/page/collectionAmount/index"], resolve);
const AmountDetails = (resolve) =>
  require(["@/page/collectionAmount/details"], resolve);
const AmountSee = (resolve) =>
  require(["@/page/collectionAmount/see"], resolve);
//const Analysis = (resolve) => require(['@/page/collectionAmount/analysis'], resolve)
const Analysis = (resolve) =>
  require(["@/page/collectionAmount/dataStatistics"], resolve);
// const Anclear = (resolve) => require(['@/page/collectionAmount/clear'], resolve)
const Anclear = (resolve) =>
  require(["@/page/collectionAmount/static"], resolve);
const Stages = (resolve) =>
  require(["@/page/collectionAmount/stages"], resolve);
const caseStatistics = (resolve) =>
  require(["@/page/caseStatistics/index"], resolve);
const openHall = (resolve) =>
  require(["@/page/caseStatistics/openHall"], resolve);
const referee = (resolve) =>
  require(["@/page/caseStatistics/referee"], resolve);

const causeFee = (resolve) =>
  require(["@/page/caseStatistics/causeFee"], resolve);
const Nullify = (resolve) =>
  require(["@/page/costStatistics/nullify"], resolve);
const Team = (resolve) => require(["@/page/directory/team"], resolve);
const Agency = (resolve) => require(["@/page/directory/agency"], resolve);
const power = (resolve) => require(["@/power/index"], resolve);
const Bank = (resolve) => require(["@/page/directory/bank"], resolve);
const ArbList = (resolve) =>
  require(["@/page/directory/arbitrate/index"], resolve);
const Letters = (resolve) => require(["@/page/letters/index"], resolve);
const LDetails = (resolve) => require(["@/page/letters/details"], resolve);
const UserGroup = (resolve) => require(["@/page/account/user"], resolve);
// import { resolve } from "core-js/fn/promise";
// import store from "../store";
// const isAdmin = localStorage.getItem("t") && store.state.user.id == 1;
const ruleView = (resolve) => require(["@/page/ruleView/ttree"], resolve);
const entrust = (resolve) => require(["@/page/entrust/index"], resolve);
const management = (resolve) => require(["@/page/management/index"], resolve);

// curs用户高亮显示对应的title
const routes = [
  {
    path: "/home",
    component: index,
    children: [
      {
        path: "/ruleView",
        component: ruleView,
        name: "ruleView",
      },
      {
        path: "/home",
        component: home,
        name: "home",
        meta: {
          curs: "-1", //焦点
          title: "首页", //面包屑
        },
      },
      {
        path: "/bank",
        component: Bank,
        name: "bank",
        meta: {
          curs: "3-7", //焦点
          title: "基础管理,金融机构",
          key: "bank:index",
        },
      },
      {
        path: "/letters",
        component: Letters,
        name: "letters",
        meta: {
          curs: "L", //焦点
          title: "档案管理",
          key: "letters:list",
        },
      },
      {
        path: "/letters/ldetails/:id",
        component: LDetails,
        name: "ldetails",
        meta: {
          curs: "L", //焦点
          title: "档案管理",
          key: "letters:info",
        },
      },
      {
        path: "/newly",
        component: welcome,
        name: "newlylist",
        meta: {
          curs: "0", //焦点
          title: "案件管理,查看",
          key: "debtor:view",
        },
      },
      {
        path: "/newly/add",
        component: newly,
        name: "newly",
        meta: {
          curs: "0",
          title: "案件管理,新增案件",
          key: "debtor:add",
        },
      },
      {
        path: "/ly/details/:id",
        component: nDetails,
        name: "lydetails",
        meta: {
          curs: "0",
          title: "案件管理,案件详情",
          key: "debtor:info",
        },
      },
      {
        path: "/payback",
        component: payback,
        name: "payback",
        meta: {
          curs: "1",
          title: "分期管理",
          key: "loan:lists",
        },
      },
      {
        path: "/entrust",
        component: entrust,
        name: "entrust",
        meta: {
          curs: "W-0",
          title: "委托代理",
          key: "entrust:agent",
        },
      },
      {
        path: "/management",
        component: management,
        name: "management",
        meta: {
          curs: "W-1",
          title: "委托管理",
          key: "management:manage",
        },
      },
      {
        path: "/Infomation",
        component: Infomation,
        name: "Infomation",
        meta: {
          curs: "Y",
          title: "案件反馈",
          key: "Infomation:lists",
        },
      },
      {
        path: "/Infomation/details/:id",
        component: InDetails,
        name: "InDetails",
        meta: {
          curs: "Y",
          title: "案件反馈",
          key: "Infomation:info",
        },
      },
      {
        path: "/payback/details/:id",
        component: paybackDetails,
        name: "paybackDetails",
        meta: {
          curs: "1",
          title: "分期管理",
          bet: true,
          key: "loan:add",
        },
      },
      {
        path: "/payback/see/:id",
        component: paybacksee,
        name: "paybacksee",
        meta: {
          curs: "1",
          title: "分期管理,分期详情",
          key: "loan:info:lists",
        },
      },
      {
        path: "/collection/amount",
        component: collectionAmount,
        name: "collectionAmount",
        meta: {
          curs: "Z",
          title: "案款管理",
          key: "payee:lists",
        },
      },
      {
        path: "/collection/details",
        component: AmountDetails,
        name: "AmountDetails",
        meta: {
          curs: "Z",
          title: "案款管理,添加案款",
          key: "credit:payee/add",
        },
      },
      {
        path: "/collection/see/:id",
        component: AmountSee,
        name: "AmountSee",
        meta: {
          curs: "Z",
          title: "案款管理,案款详情",
          key: "payee:info:lists",
        },
      },
      {
        path: "/examine/manager",
        component: examineManage,
        name: "examineManage",
        meta: {
          curs: "2",
          title: "审核管理",
          key: "info:audit:lists",
        },
      },
      {
        path: "/directory/manager",
        component: directoryManage,
        name: "directoryManage",
        meta: {
          curs: "3-0",
          title: "基础管理,法院目录",
          key: "court:list",
        },
      },
      {
        path: "/directory/add",
        component: directoryAdd,
        name: "directoryAdd",
        meta: {
          curs: "3-0",
          title: "基础管理,法院目录,新增法院",
          key: "court:editWithAudit",
        },
      },
      {
        path: "/directory/edit",
        component: directoryAdd,
        name: "directoryAdd",
        meta: {
          curs: "3-0",
          title: "基础管理,法院目录,修改法院",
          key: "court:editWithAudit",
        },
      },
      {
        path: "/subjectAction/manager",
        component: subjectActionManage,
        name: "subjectActionManage",
        meta: {
          curs: "3-2",
          title: "基础管理,案件主体",
          key: "accsuer:index",
        },
      },
      {
        path: "/directory/car",
        component: allCar,
        name: "allCar",
        meta: {
          curs: "3-3",
          title: "基础管理,业务类型",
          key: "car:index",
        },
      },
      {
        path: "/directory/action",
        component: action,
        name: "action",
        meta: {
          curs: "3-4",
          title: "基础管理,案件案由",
          key: "reason:index",
        },
      },
      {
        path: "/directory/over",
        component: overStep,
        name: "over",
        meta: {
          curs: "3-5",
          title: "基础管理,进度期限",
          key: "over:index",
        },
      },
      {
        path: "/directory/team",
        component: Team,
        name: "team",
        meta: {
          curs: "3-6",
          title: "基础管理,业务部门",
          key: "team:index",
        },
      },
      {
        path: "/directory/agency",
        component: Agency,
        name: "agency",
        meta: {
          curs: "3-z",
          title: "基础管理,代理模式",
          key: "agency:index",
        },
      },
      {
        path: "/arbitrate/list",
        component: ArbList,
        name: "ArbList",
        meta: {
          curs: "3-8",
          title: "基础管理,仲裁机构",
          key: "arbitrate:index",
        },
      },
      {
        path: "/litigation/statistics",
        component: litigationStatistics,
        name: "litigationStatistics",
        meta: {
          curs: "4-0",
          title: "统计管理,案件统计",
          key: "statis:cause",
        },
      },
      {
        path: "/case/statistics",
        component: caseStatistics,
        name: "caseStatistics",
        meta: {
          curs: "4-1",
          title: "统计管理,法院统计",
          key: "statis:court:lists",
        },
      },
      {
        path: "/case/step",
        component: stepStatistics,
        name: "stepStatistics",
        meta: {
          curs: "4-10",
          title: "统计管理,进度统计",
          key: "statis:step:lists",
        },
      },
      {
        path: "/case/openhall",
        component: openHall,
        name: "openHall",
        meta: {
          curs: "4-7",
          title: "统计管理,开庭统计",
          key: "statis:openHall:lists",
        },
      },
      {
        path: "/case/referee",
        component: referee,
        name: "referee",
        meta: {
          curs: "4-8",
          title: "统计管理,文书统计",
          key: "statis:referee:lists",
        },
      },
      {
        path: "/case/causeFee",
        component: causeFee,
        name: "causeFee",
        meta: {
          curs: "4-9",
          title: "统计管理,费用统计",
          key: "statis:causeFee:lists",
        },
      },
      {
        path: "/litigation/analysis",
        component: Analysis,
        name: "Analysis",
        meta: {
          curs: "4-3",
          title: "统计管理,新增数据统计",
          key: "statis:ywfx:lists",
        },
      },
      {
        path: "/litigation/clear",
        component: Anclear,
        name: "Anclear",
        meta: {
          curs: "4-5",
          title: "统计管理, 案款统计",
          key: "statis:settle:cause",
        },
      },
      {
        path: "/litigation/stages",
        component: Stages,
        name: "Stages",
        meta: {
          curs: "4-6",
          title: "统计管理, 分期统计",
          key: "statis:credit:lists",
        },
      },
      {
        path: "/litigation/nullify",
        component: Nullify,
        name: "nullify",
        meta: {
          curs: "4-4",
          title: "统计管理,作废统计",
          key: "statis:cancel:lists",
        },
      },
      {
        path: "/account/OperationLog",
        component: accountOperationLog,
        name: "accountOperationLog",
        meta: {
          curs: "3-1",
          title: "账号管理,操作日志",
        },
      },
      {
        path: "/account/loginlist",
        component: accountLoginlist,
        name: "accountLoginlist",
        meta: {
          curs: "3-1",
          title: "账号管理,登录日志",
        },
      },
      {
        path: "/account/manager",
        component: accountManage,
        name: "accountManage",
        meta: {
          curs: "3-1",
          title: "账号管理,用户管理",
        },
      },
      {
        path: "/account/group",
        component: accountGroup,
        name: "accountGroup",
        meta: {
          curs: "3-1",
          title: "账号管理,权限管理",
        },
      },
    ],
  },
  // 权限分配管理
  {
    path: "/power",
    name: "power",
    component: power,
  },
  // 登录
  {
    name: "login",
    path: "/login",
    component: login,
  },
];
// if (isAdmin) {
//   routes[0].children.push(
//     {
//       path: "/account/add",
//       component: accountAdd,
//       name: "accountAdd",
//       meta: {
//         curs: "3-1",
//         title: "基础管理,账户信息管理,新增账户",
//       },
//     },
//     {
//       path: "/account/edit",
//       component: accountAdd,
//       name: "accountAdd",
//       meta: {
//         curs: "3-1",
//         title: "基础管理,账户信息管理,修改账户",
//       },
//     },
//     {
//       path: "/account/user",
//       component: UserGroup,
//       name: "userGroup",
//       meta: {
//         curs: "3-1",
//         title: "基础管理,账户信息管理,用户组管理",
//       },
//     }
//   );
// }
export default routes;
